import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Button } from '@bosch/react-frok'

import useWindowSize from '@/hooks/useWindowSize'
import utils from '@/utils/utils'
import type { RootState } from '@/utils/store/store'

import './ProfileBadge.scss'

type ProfileBadgeProps = {
    // opens the user flyout of the header next to the button that was clicked
    onClick: (event: React.MouseEvent<HTMLElement>) => void
}

const ProfileBadge = ({ onClick }: ProfileBadgeProps) => {
    const { width } = useWindowSize()
    const authenticationState = useSelector((state: RootState) => state.authentication)
    const user = useMemo(
        () => ({ ...authenticationState.information }),
        [authenticationState.information]
    )

    return (
        <Button className="profile-badge" mode="integrated" onClick={onClick}>
            <div className="content">
                {utils.getProfilePicture(user)}
                {width >= 1194 ? <div className="profile-name">{user.account?.name}</div> : null}
            </div>
        </Button>
    )
}

export default ProfileBadge
